import { params } from "../../../components/utility";

let QueryParams = (value) => {
	try {
		const clone = structuredClone(value);

		const {
			keywordSearch: keyword,
			locationFacet: cities,
			industryFacet: industry,
			companyTypesFacet: type,
			pagination: pagination,
			sortingRule: sort,
		} = clone;

		const paramsObj = {
			keyword: keyword,
			cities: cities,
			industry: industry,
			type: type,
			page: pagination,
			sort: sort,
		};

		Object.keys(paramsObj).forEach((key) => {
			if(key === 'page') {
				params['page_number'] = paramsObj[key]
			} else {
				params[key] = paramsObj[key];
			}
		});
	} catch (e) {
		console.error(e);
	}
};

export default QueryParams;
